__turbopack_context__.v({
  "categoryBrandText": "styles-module__1jVUxW__categoryBrandText",
  "container": "styles-module__1jVUxW__container",
  "purchasedText": "styles-module__1jVUxW__purchasedText",
  "textWrapper": "styles-module__1jVUxW__textWrapper",
});
